/* eslint-disable */
import { TdsGlobalHeader } from '@trv-tds/react';
import React from 'react';

function TravHeader() {
    return (
        <TdsGlobalHeader
            homehref="https://www.travelers.com"
            homelabel="Travelers.com"
            product="Premium Audit"
            role="banner"
            data-testid="global-header"
        ></TdsGlobalHeader>
    );
}

export default TravHeader;
